module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/hedge-trimming/size-2-21daa784dc0681460141fc4b0ccc6d5f.svg";